import { ShowDataFor } from 'utils/components/ShowDataFor/ShowDataFor';
import { initialFillsGraphStreamedDataConfiguration } from 'widgets/fillsGraph/store/streamedData/FillsGraphStreamedDataHelpers';
import { PnlBenchmark } from 'utils/PnL';

export type PlCapsuleView = 'chart' | 'values';

export interface PlCapsuleConfigState {
    symbol?: string;
    showDataFor?: ShowDataFor;
    view: PlCapsuleView;
    pnlChartBenchmark: PnlBenchmark;
    hideRealized?: boolean;
    showUnrealized?: boolean;
    showTotal?: boolean;
}

export const initialPlCapsuleConfigState: PlCapsuleConfigState = {
    ...initialFillsGraphStreamedDataConfiguration,
    pnlChartBenchmark: PnlBenchmark.Arrival,
    showDataFor: ShowDataFor.AllDay,
    view: 'chart',
};
